import { EntityType } from "@shared/enums/general"
import { CreateInternalNoteRequest } from "@shared/zod/schemas/requests/item"
import { DefaultResponse } from "@shared/zod/schemas/responses/common"
import { InternalNoteResponse } from "@shared/zod/schemas/responses/internalNote"
import { InternalNoteCreationResponse } from "@shared/zod/schemas/responses/item"

import { axiosAuth } from "./generic/AxiosInterceptor/AxiosInterceptor"

export const get = async (entityType: EntityType, entityId: string): Promise<InternalNoteResponse[]> => {
  const resp = await axiosAuth({
    url: `/internalnotes/${entityType}/${entityId}`,
    method: "get",
  })

  return resp.data
}

export const create = async (req: CreateInternalNoteRequest): Promise<InternalNoteCreationResponse> => {
  const resp = await axiosAuth({
    url: "/internalnotes",
    method: "post",
    data: req,
  })

  return resp.data
}

export const edit = async (id: string, message: string): Promise<DefaultResponse> => {
  const resp = await axiosAuth({
    url: `/internalnotes/${id}`,
    method: "patch",
    data: { message },
  })
  return resp.data
}

export const remove = async (id: string): Promise<DefaultResponse> => {
  const resp = await axiosAuth({
    url: `/internalnotes/${id}`,
    method: "delete",
  })

  return resp.data
}
